import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=325316fc&scoped=true&"
import script from "./Procedure.vue?vue&type=script&lang=js&"
export * from "./Procedure.vue?vue&type=script&lang=js&"
import style0 from "./Procedure.vue?vue&type=style&index=0&id=325316fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325316fc",
  null
  
)

export default component.exports